import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("cm_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Silence les 403 RBAC non catchés (collaborateurs à droits restreints) : évite
// l'overlay d'erreurs en dev et le bruit console — les guards UI gèrent l'affichage.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    if (event.reason?.isAxiosError && event.reason.response?.status === 403) {
      event.preventDefault();
    }
  });
}

// ======= Formatters =======
export const formatEUR = (amount) => {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(amount || 0);
};

export const formatEURDecimal = (amount) => {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount || 0);
};

// Montant estimatif d'une option (affichage) — respecte le plafond des options par jour.
// Le montant définitif reste calculé côté serveur.
export const capOptionAmount = (o, days) => {
  if (!o) return 0;
  if (!o.per_day) return o.price || 0;
  const raw = (o.price || 0) * days;
  const cap = o.price_cap;
  return cap != null && cap > 0 ? Math.min(raw, cap) : raw;
};


// Date JJ/MM/AAAA
export const formatDateFR = (isoStr) => {
  if (!isoStr) return "";
  const d = new Date(isoStr + (isoStr.length === 10 ? "T00:00:00" : ""));
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

export const toISODate = (d) => {
  if (!d) return "";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const diffDays = (startISO, endISO) => {
  if (!startISO || !endISO) return 0;
  const s = new Date(startISO);
  const e = new Date(endISO);
  const ms = e.getTime() - s.getTime();
  return Math.max(1, Math.round(ms / (1000 * 60 * 60 * 24)) + 1);
};

export const formatApiError = (detail) => {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

const FALLBACK_PHOTO =
  "https://images.unsplash.com/photo-1511919884226-fd3cad34687c?w=1200&q=80";

// Resolve a vehicle photo reference to a fully-qualified URL.
// - null/empty → fallback Unsplash
// - http(s) → as-is (legacy URLs)
// - anything else → served by our public object-storage endpoint
export const photoUrl = (p) => {
  if (!p) return FALLBACK_PHOTO;
  if (/^https?:\/\//i.test(p)) return p;
  return `${API}/public/vehicle-photos/${p}`;
};

export const downloadCSV = async (path, filename) => {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
